import { render } from "./lec_reg_editnew.vue?vue&type=template&id=0904cf5f&scoped=true"
import script from "./lec_reg_editnew.vue?vue&type=script&lang=js"
export * from "./lec_reg_editnew.vue?vue&type=script&lang=js"

import "./css/common.scss?vue&type=style&index=0&id=0904cf5f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0904cf5f"]])

export default __exports__